import React, { useContext } from "react";
import { Button, Divider, Stack, Tooltip, Typography } from "@mui/material";
import OptionArea from "./optionArea/OptionArea";
import TitleArea from "./TitleArea";
import QuestionTextsArea from "./questionTextsArea/QuestionTextsArea";
import { QuestionsContext, SnackbarContext } from "../../../../../../provider/MyContexts";
import { NavigateBefore, NavigateNext } from "@mui/icons-material";
import { getQuestionIds } from "../../../../../../commands/questions/excelInfo";
import { importQuestion } from "../../../../../../commands/questions/import";
import {
  insertQuestionBottom,
  insertQuestionToExcel,
} from "../../../../../../commands/questions/export";

type Props = {
  foldDetailWindow: () => void;
};

export default function QuestionModal(props: Props) {
  const { foldDetailWindow } = props;

  // const { modalState, handleModalClose } = useContext(ModalContext);
  const { selectedQuestion } = useContext(QuestionsContext);

  // if (modalState.content != "questionGenerate" || !selectedQuestion) {
  if (!selectedQuestion) {
    return <></>;
  }

  let isEmpty = false;

  if (selectedQuestion.questionType.includes("マトリクス")) {
    if (
      !selectedQuestion.options.length &&
      !selectedQuestion.loop.length &&
      !selectedQuestion.questionText
    ) {
      isEmpty = true;
    }
  } else {
    if (!selectedQuestion.options.length && !selectedQuestion.questionText) {
      isEmpty = true;
    }
  }

  return (
    // <Modal open={modalState.open} onClose={handleModalClose} disableAutoFocus>
    // <Box
    //   sx={{
    //     display: "flex",
    //     alignItems: "center",
    //     justifyContent: "center",
    //     height: "100vh",
    //     px: 2,
    //   }}
    //   onClick={() => handleModalClose()}
    // >
    <Stack
      direction={"column"}
      flex={1}
      sx={{
        position: "relative",
        width: "100%",
        maxWidth: "800px",
        bgcolor: "white",
        paddingTop: 2,
        paddingX: 2,
        height: "100%",
        overflowY: "auto",
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {/* <Box
            sx={{
              position: "absolute",
              right: "1.25rem",
              top: "1rem",
            }}
          >
            <CloseIcon onClick={() => handleModalClose()} sx={{ cursor: "pointer" }} />
          </Box> */}
      <TitleArea />
      {isEmpty ? (
        <EmptyContents />
      ) : (
        <Stack flex={1} direction={"column"} width={"100%"}>
          <QuestionTextsArea />
          <OptionArea />
          {/* <Divider flexItem /> */}
        </Stack>
      )}

      <FooterArea foldDetailWindow={foldDetailWindow} />
    </Stack>
    // {/* </Box> */}
    // </Modal>
  );
}

function EmptyContents() {
  const { selectedQuestion, isLoading, addInitOption, generateQuestion } =
    useContext(QuestionsContext);

  return (
    <Stack
      flex={1}
      direction={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      spacing={2}
    >
      <Typography
        // sx={{
        //   color: "#666",
        //   fontWeight: 600,
        // }}
        variant="body_L"
      >
        {"設問データがありません。"}
      </Typography>
      <Stack direction={"row"} spacing={2}>
        <Button
          variant="outlined"
          onClick={() => {
            addInitOption(selectedQuestion.questionType);
          }}
          disabled={!selectedQuestion.questionType}
        >
          自分でつくる
        </Button>
        <Button
          variant="contained"
          disabled={!selectedQuestion.questionTitle || !selectedQuestion.questionType}
          loading={isLoading}
          loadingPosition="start"
          onClick={() => {
            generateQuestion();
          }}
        >
          AIサポート
        </Button>
      </Stack>
    </Stack>
  );
}

import { useKey } from "react-use";

function FooterArea(props: { foldDetailWindow: () => void }) {
  const { foldDetailWindow } = props;

  const {
    questions,
    getNextQuestion,
    getPrevQuestion,
    moveToNextQuestion,
    moveToPrevQuestion,
    editSheet,
    selectedQuestion,
    updateQuestionById,
  } = useContext(QuestionsContext);
  const { handleSnackbarOpen } = useContext(SnackbarContext);

  const nextQuestion = questions[getNextQuestion()];
  const prevQuestion = questions[getPrevQuestion()];

  const maxLength = 8;

  async function handleImportQuestion() {
    const { excel } = await getQuestionIds([], editSheet);

    console.log(excel);
    if (!excel.includes(selectedQuestion.questionId)) {
      handleSnackbarOpen("error", "この設問IDはExcelに存在しません。");
      return null;
    }

    const lastQuestionIdInExcel = excel[excel.length - 1];
    const questionImported = await importQuestion(
      editSheet,
      selectedQuestion.questionId,
      excel.includes(nextQuestion.questionId) &&
        lastQuestionIdInExcel != selectedQuestion.questionId
        ? nextQuestion.questionId
        : undefined
    );
    // todo: 差分を表示してOKかどうかを問う
    // compareObjects(selectedQuestion, questionImported)
    await updateQuestionById(selectedQuestion.questionId, questionImported);
    handleSnackbarOpen("info", "Excelから設問データを読み込みました。");
  }

  async function handleExportQuestion() {
    const { excel } = await getQuestionIds([], editSheet);
    if (!excel.includes(selectedQuestion.questionId)) {
      await insertQuestionBottom(editSheet, selectedQuestion);
    } else {
      await insertQuestionToExcel(editSheet, selectedQuestion, nextQuestion);
    }
    handleSnackbarOpen("info", "設問データをExcelに反映しました。");
  }

  // // Ctrl + →
  // useKey(
  //   (event) => event.ctrlKey && event.key === "ArrowRight",
  //   () => {
  //     console.log("Ctrl + → detected");
  //     moveToNextQuestion();
  //   },
  //   {},
  //   []
  // );

  // // Ctrl + ←
  // useKey(
  //   (event) => event.ctrlKey && event.key === "ArrowLeft",
  //   () => {
  //     console.log("Ctrl + ← detected");
  //     moveToPrevQuestion();
  //   },
  //   {},
  //   []
  // );

  const isExportActive =
    selectedQuestion.questionTitle &&
    selectedQuestion.options.length > 0 &&
    selectedQuestion.questionType &&
    selectedQuestion.questionText
      ? true
      : false;

  return (
    <Stack
      width={"100%"}
      direction={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      sx={{
        position: "sticky",
        zIndex: 1,
        bottom: 0,
        backgroundColor: "white",
        borderTop: "1px solid #ddd",
      }}
    >
      <Stack direction={"row"} spacing={4} marginY={2}>
        <Tooltip title="設問IDを目印にExcelから設問を読み込みます">
          <Button
            variant="outlined"
            sx={{
              width: 180,
              textTransform: "none",
              marginTop: 1,
              marginBottom: "-1rem",
            }}
            onClick={async () => handleImportQuestion()}
          >
            Excelから読み込む
          </Button>
        </Tooltip>
        <Tooltip title="設問IDがExcelに存在していない場合は、一番下に追加されます">
          <Button
            variant="contained"
            sx={{
              width: 180,
              textTransform: "none",
              marginTop: 1,
              marginBottom: "-1rem",
            }}
            disabled={!isExportActive}
            onClick={async () => handleExportQuestion()}
          >
            Excelに反映する
          </Button>
        </Tooltip>
        <Divider orientation="vertical" />
        <Button variant="text" onClick={() => foldDetailWindow()}>
          <Typography variant="button">とじる</Typography>
        </Button>
      </Stack>
      <Stack
        direction={"row"}
        spacing={2}
        justifyContent={"space-between"}
        width={"100%"}
        paddingX={4}
      >
        <Button variant="text" size="small" onClick={() => moveToPrevQuestion()}>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <NavigateBefore fontSize="large" />
            <Typography
              variant="label_M"
              sx={{
                whiteSpace: "pre-wrap",
              }}
            >
              {`前の設問へ\n${prevQuestion?.questionId} ${prevQuestion?.questionTitle.slice(0, maxLength)}`}
            </Typography>
          </Stack>
        </Button>
        <Button variant="text" size="small" onClick={() => moveToNextQuestion()}>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Typography
              variant="label_M"
              sx={{
                whiteSpace: "pre-wrap",
              }}
            >
              {`次の設問へ\n${nextQuestion?.questionId} ${nextQuestion?.questionTitle.slice(0, maxLength)}`}
            </Typography>
            <NavigateNext fontSize="large" />
          </Stack>
        </Button>
      </Stack>
    </Stack>
  );
}
